import { EnvironmentProviders, makeEnvironmentProviders, Type } from '@angular/core';
import * as ApiClient from './generated/api-client';

function isApiClientExport(entry: [string, unknown]): entry is [string, Type<unknown>] {
  const [name, value] = entry;
  return typeof value === 'function' && name.endsWith('Client');
}

/**
 * Registra todos los clientes NSwag generados en el DI tree de Angular.
 *
 * Al regenerar `api-client.ts` con NSwag, los nuevos clientes quedan
 * registrados automáticamente — no hay que tocar este archivo ni app.config.ts.
 *
 * @param apiBaseUrl URL base del servidor (sin el segmento `/api`).
 *                  El cliente generado agrega el path correcto por su cuenta.
 */
export function provideApiClients(apiBaseUrl: string): EnvironmentProviders {
  // Usar las claves exportadas, que se conservan incluso con minificación.
  const apiClientExports = Object.entries(ApiClient) as [string, unknown][];
  const clients = apiClientExports
    .filter(isApiClientExport)
    .map(([, value]) => value);

  return makeEnvironmentProviders([
    { provide: ApiClient.API_BASE_URL, useValue: apiBaseUrl },
    ...clients,
  ]);
}
